import { useState, useEffect } from 'react'
import { Auth } from 'aws-amplify'
import { CognitoIdToken } from 'amazon-cognito-identity-js'
import {
    buildRequestHeaders,
    isAdmin,
    isMultipleOrganization,
} from '../../../../Utils/ServerUtil'
import { getCurrentOrganizationUrlParam } from '../../../../Utils/helpers'
import config from '../../../../config/runtime'

// Define the type for evaluation data
interface EvaluationData {
    // Add your evaluation data properties here
    [key: string]: any
}

export const useEvaluationData = (evalID: string | null) => {
    const [evaluationData, setEvaluationData] = useState<EvaluationData | null>(
        null
    )
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<Error | null>(null)
    const [tokenRefreshError, setTokenRefreshError] = useState(false)

    useEffect(() => {
        console.log("EvalId----", {evalID})
        if (!evalID) return

        const fetchEvaluation = async () => {
            setIsLoading(true)
            setError(null)
            let jwtToken: string | undefined

            try {
                const session = await Auth.currentSession()
                const idToken: CognitoIdToken = session.getIdToken()
                jwtToken = idToken.getJwtToken()
            } catch (e) {
                try {
                    const session = await Auth.currentSession()
                    const idToken: CognitoIdToken = session.getIdToken()
                    jwtToken = idToken.getJwtToken()
                } catch (e) {
                    console.error('Error refreshing token', e)
                    setTokenRefreshError(true)
                    setError(new Error('Failed to refresh authentication token'))
                    setIsLoading(false)
                    return
                }
            }

            // Use the shared helper function
            const headers = buildRequestHeaders(jwtToken)
            const options = { method: 'GET', headers }
            const url = `${config.API_ENDPOINT}/evaluations/${evalID}`

            try {
                const response = await fetch(url, options)
                if (!response.ok) {
                    throw new Error(`Request failed with status: ${response.status}`)
                }
                const itemData = await response.json()
                setEvaluationData(itemData)
            } catch (error) {
                const err = error instanceof Error ? error : new Error('An unknown error occurred')
                setError(err)
                console.error('Error fetching evaluation:', err)
            } finally {
                setIsLoading(false)
            }
        }

        fetchEvaluation()
    }, [evalID])

    return {
        evaluationData,
        isLoading,
        error,
        tokenRefreshError,
    }
}
